// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._11Ey6ua42s0_yW22qoK2I2{display:flex;flex-direction:column}._2yC1TJkoSt1y33q9IR-TY5:not(:last-child){margin-bottom:1.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_11Ey6ua42s0_yW22qoK2I2",
	"statLine": "_2yC1TJkoSt1y33q9IR-TY5"
};
module.exports = ___CSS_LOADER_EXPORT___;
